'use strict'

// Radio options.
const RADIO_YES_NO_OPTIONS = [
  {label: 'Yes', value: 'Y'},
  {label: 'No', value: 'N'}
]

const RADIO_YES_NO_BOOLEAN_OPTIONS = [
  {label: 'Yes', value: true},
  {label: 'No', value: false}
]

// Season options.
const SELECT_SEASON_OPTIONS = [
  {label: 'Fall', value: 'F'},
  {label: 'Winter', value: 'W'},
  {label: 'Spring', value: 'S'},
  {label: 'None', value: 'U'}
]

// Season options.
const SELECT_SPORT_TYPE_OPTIONS = [
  {label: 'Team', value: 'T'},
  {label: 'Individual', value: 'I'},
  {label: 'None', value: 'U'}
]

// Gender options
const RADIO_GENDER_OPTIONS = [
  {label: 'Male', value: 'M'},
  {label: 'Female', value: 'F'},
  {label: 'Mixed', value: 'X'}
]

// Gender options
const RADIO_GENDER_OPTIONS_MF_ONLY = [
  {label: 'Male', value: 'M'},
  {label: 'Female', value: 'F'}
]

// Division options
const RADIO_DIVISION_OPTIONS = [
  {label: 'I', value: '1'},
  {label: 'II', value: '2'},
  {label: 'III', value: '3'}
]

// Division options
const RADIO_SUBDIVISION_OPTIONS = [
  {label: 'None', value: '0'},
  {label: 'FBS', value: '1'},
  {label: 'FCS', value: '2'},
  {label: 'I', value: '3'}
]

export default {
  RADIO_YES_NO_OPTIONS: RADIO_YES_NO_OPTIONS,
  RADIO_YES_NO_BOOLEAN_OPTIONS: RADIO_YES_NO_BOOLEAN_OPTIONS,
  SELECT_SEASON_OPTIONS: SELECT_SEASON_OPTIONS,
  SELECT_SPORT_TYPE_OPTIONS: SELECT_SPORT_TYPE_OPTIONS,
  RADIO_GENDER_OPTIONS: RADIO_GENDER_OPTIONS,
  RADIO_DIVISION_OPTIONS: RADIO_DIVISION_OPTIONS,
  RADIO_SUBDIVISION_OPTIONS: RADIO_SUBDIVISION_OPTIONS,
  RADIO_GENDER_OPTIONS_MF_ONLY: RADIO_GENDER_OPTIONS_MF_ONLY
}



// WEBPACK FOOTER //
// ./src/js/common/DataTableEditorHelper.js